<template>
  <div class="sidebar-left">
    <div class="sidebar">
      <div class="sidebar-content email-app-sidebar">
        <div class="email-app-menu">
          <div class="form-group-compose text-center compose-btn">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              block
              @click="$emit('update:shall-show-email-compose-modal', true); $emit('close-left-sidebar')"
            >
              Compose
            </b-button>
          </div>
          <vue-perfect-scrollbar
            :settings="perfectScrollbarSettings"
            class="sidebar-menu-list scroll-area"
          >
            <!-- Filters -->
            <b-list-group class="list-group-messages">
              <b-list-group-item
                v-for="filter in emailFilters"
                :key="filter.title + $route.path"
                :to="filter.route"
                :active="isDynamicRouteActive(filter.route)"
                @click="$emit('close-left-sidebar')"
              >
                <feather-icon
                  :icon="filter.icon"
                  size="18"
                  class="mr-75"
                />
                <span class="align-text-bottom line-height-1">{{ filter.title }}</span>
                <b-badge
                  pill
                  :variant="resolveFilterBadgeColor(filter.title)"
                  class="float-right"
                >
                  {{ emailsMeta[filter.folder.toLowerCase()] }}
                </b-badge>
              </b-list-group-item>
            </b-list-group>
          </vue-perfect-scrollbar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import {
  BButton, BListGroup, BListGroupItem, BBadge,
} from 'bootstrap-vue'
import { isDynamicRouteActive } from '@core/utils/utils'
import Ripple from 'vue-ripple-directive'

export default {
  directives: {
    Ripple,
  },
  components: {

    // BSV
    BButton,
    BListGroup,
    BListGroupItem,
    BBadge,

    // 3rd Party
    VuePerfectScrollbar,
  },
  props: {
    shallShowEmailComposeModal: {
      type: Boolean,
      required: true,
    },
    emailsMeta: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
    }

    const emailFilters = [
      {
        title: 'New', folder: 'new', icon: 'FolderIcon', route: { name: 'apps-enquiry' },
      },
      {
        title: 'Maintenance', folder: 'maintenance', icon: 'FolderIcon', route: { name: 'apps-enquiry-folder', params: { folder: 'maintenance' } },
      },
      {
        title: 'Breakdown', folder: 'breakdown', icon: 'FolderIcon', route: { name: 'apps-enquiry-folder', params: { folder: 'breakdown' } },
      },
      {
        title: 'Line Configuration', folder: 'lineconfig', icon: 'FolderIcon', route: { name: 'apps-enquiry-folder', params: { folder: 'lineconfig' } },
      },
      {
        title: 'Deleted', folder: 'deleted', icon: 'TrashIcon', route: { name: 'apps-enquiry-folder', params: { folder: 'deleted' } },
      },
    ]

    const resolveFilterBadgeColor = filter => {
      if (filter === 'Maintenance') return 'light-warning'
      if (filter === 'Breakdown') return 'light-info'
      if (filter === 'Line Configuration') return 'light-secondary'
      if (filter === 'Deleted') return 'light-danger'
      return 'light-primary'
    }

    return {
      // UI
      perfectScrollbarSettings,
      isDynamicRouteActive,
      resolveFilterBadgeColor,

      // Filter & Labels
      emailFilters,
    }
  },
}
</script>

<style>

</style>
